<template>
    <v-card>
        <v-card-title class="text-h5 dialog-title pl-0 pr-0"
            >Venta de kit digital</v-card-title
        >
        <v-card-text class="mt-2" style="max-height: 700px; overflow-y: auto">
            <v-form class="mt-3">
                <v-row align="center">
                    <v-col cols="12" md="4">
                        <v-text-field
                            label="Núm Acuerdo"
                            v-model="gasto.num_acuerdo"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-autocomplete
                            label="Razón Social"
                            :items="usuarios"
                            item-text="nombres"
                            item-value="id"
                            v-model="gasto.id_cliente"
                            dense
                            outlined
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-autocomplete
                            label="Responsable"
                            :items="empleados"
                            item-text="nombres"
                            item-value="id"
                            v-model="gasto.id_responsable"
                            dense
                            outlined
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-autocomplete
                            dense
                            outlined
                            :items="empleados"
                            item-value="id"
                            item-text="nombre"
                            label="Vendedor"
                            v-model="gasto.id_vendedor"
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Importe"
                            v-model="gasto.importe"
                            type="number"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="IVA"
                            v-model="gasto.iva"
                            type="number"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-autocomplete
                            label="Categoría"
                            :items="categorias"
                            item-text="nombre"
                            item-value="id"
                            v-model="gasto.id_categoria"
                            dense
                            outlined
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <date-select
                            label="Fecha de firma"
                            v-model="gasto.fecha_firma"
                            dense
                            outlined
                        >
                        </date-select>
                    </v-col>

                    <v-col cols="12" md="6">
                        <date-select
                            label="Fecha de reunión"
                            v-model="gasto.fecha_reunion"
                            dense
                            outlined
                        >
                        </date-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <date-select
                            label="Fecha de pago de IVA"
                            v-model="gasto.fecha_iva"
                            dense
                            outlined
                        >
                        </date-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <date-select
                            label="Fecha de facturación"
                            v-model="gasto.fecha_factura"
                            dense
                            outlined
                        >
                        </date-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Bono digital"
                            v-model="gasto.bono_digital"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <date-select
                            label="Justificación 1"
                            v-model="gasto.justificacion_1"
                            dense
                            outlined
                        >
                        </date-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Cobro 1"
                            v-model="gasto.cobro_1"
                            type="number"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <date-select
                            label="Justificación 2"
                            v-model="gasto.justificacion_2"
                            dense
                            outlined
                        >
                        </date-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Cobro 2"
                            v-model="gasto.cobro_2"
                            type="number"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            label="Observaciones"
                            v-model="gasto.observaciones"
                            dense
                            outlined
                        ></v-textarea>
                    </v-col>
                    <v-col class="mt-0 pt-0 pb-0">
                        <v-checkbox
                            class="mt-0"
                            label="Marque la casilla para desestimar al cliente de esta venta"
                            v-model="gasto.desestimar"
                        ></v-checkbox>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
            <v-btn
                v-if="!gasto.id"
                :disabled="isloading"
                color="success"
                class="white--text"
                @click="saveGasto"
                >Guardar</v-btn
            >
            <v-btn
                @click="saveGasto"
                v-if="gasto.id"
                :disabled="isloading"
                color="success"
                class="white--text"
                >Actualizar</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ["value", "categorias", "usuarios", "estados", "empleados"],
    data() {
        return {
            save_tipo: {},

            gasto: { gasto: 0, iva: 21 },
        };
    },
    watch: {
        value(val) {
            this.gasto = val;
        },
        gasto(val) {
            this.$emit("input", val);
        },
    },
    created() {
        if (this.value != null) this.gasto = this.value;
    },
    methods: {
        saveGasto() {
            const self = this;
            axios
                .post("api/save-venta-kit", this.gasto)
                .then(function (response) {
                    self.$emit("close_modal");
                });
        },
    },
    filters: {},
    computed: {
        user() {
            return this.$store.getters.getuser;
        },
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
